/**
 * Numeric, per-segment comparison of two dotted version strings (e.g. '0.1.2'). Returns 1 if
 * a > b, -1 if a < b, 0 if equal. Segments compare as numbers ('0.1.10' > '0.1.9'); missing
 * trailing segments count as 0. Same rule as the cockpit's `compareVersions`, so the served
 * version must carry no suffix (bpp-stella strips `-SNAPSHOT` before serving it).
 */
export function compareVersions(a: string, b: string): number {
  const segmentsA = a.split('.').map(Number);
  const segmentsB = b.split('.').map(Number);
  const length = Math.max(segmentsA.length, segmentsB.length);

  for (let i = 0; i < length; i++) {
    const diff = (segmentsA[i] ?? 0) - (segmentsB[i] ?? 0);
    if (diff !== 0) {
      return Math.sign(diff);
    }
  }

  return 0;
}
